<template>
  <div class="create-team">
    <div class="btn-wrapper mb-10 move-right">
      <router-link
        to="/admin/hrm/leave/settings/leave-approval"
        class="btn-back"
      >
        <span>Back</span>
      </router-link>
    </div>
    <el-form
      :model="leaveApprovalForm"
      :rules="rules"
      ref="leaveApprovalForm"
      class="white-bg form"
      label-position="left"
      label-width="200px"
      v-loading="loading"
    >
      <h3 class="text-gray bold mt-0 mb-40">Create New Leave Approver</h3>
      <h3>Approval List</h3>
      <div class="mt-20 ">
        <el-form-item
          label="Approval List Name"
          prop="description"
          class="mt-20"
        >
          <el-input
            placeholder="Type name of list e.g Accounts Staff"
            name="leave approval"
            type="text"
            v-model="leaveApprovalForm.description"
          ></el-input>
        </el-form-item>
      </div>
      <el-form-item label="Approval Based on" prop="category_type">
        <el-radio-group v-model="leaveApprovalForm.category_type" class="mt-20">
          <el-radio label="employees">Employee</el-radio>
          <el-radio label="station_grade">Grades</el-radio>
          <el-radio label="department">Department</el-radio>
          <el-radio label="branch">Branch</el-radio>
        </el-radio-group>
      </el-form-item>
      <div
        class="mt-20 "
        v-if="
          leaveApprovalForm.category_type !== 'employees' &&
            leaveApprovalForm.category_type !== 'branch'
        "
      >
        <el-form-item
          prop="branch_id"
          label="Select Branch"
          :rules="{
            required: true,
            message: 'Please select branch',
            trigger: 'blur',
          }"
        >
          <el-select
            v-model="leaveApprovalForm.branch_id"
            placeholder="Select"
            name="branch_id"
          >
            <el-option
              v-for="branch in branches"
              :key="branch.id"
              :label="branch.station_name"
              :value="branch.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="mt-20 " v-show="leaveApprovalForm.category_type === 'branch'">
        <el-form-item prop="branches" label="Select Branch">
          <el-select
            v-model="leaveApprovalForm.branches"
            placeholder="Select"
            name="branch"
            multiple
          >
            <el-option
              v-for="branch in branches"
              :key="branch.id"
              :label="branch.station_name"
              :value="branch.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>

      <div
        class="mt-20 "
        v-show="leaveApprovalForm.category_type === 'department'"
      >
        <el-form-item
          prop="departments"
          class="mt-20"
          label="Select Department"
        >
          <el-select
            v-model="leaveApprovalForm.departments"
            placeholder="Select"
            multiple
          >
            <el-option
              v-for="department in departments"
              :key="department.id"
              :label="department.department_name"
              :value="department.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div
        class="mt-20 "
        v-show="leaveApprovalForm.category_type === 'employees'"
      >
        <el-form-item prop="employees" label="Select Employee">
          <el-select
            v-model="leaveApprovalForm.employees"
            placeholder="Select"
            filterable
            remote
            :remote-method="searchEmployees"
            multiple
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div
        class="mt-20 "
        v-show="leaveApprovalForm.category_type === 'station_grade'"
      >
        <el-form-item class="mt-20" prop="grades" label="Select Grade">
          <el-select
            v-model="leaveApprovalForm.grades"
            placeholder="Select"
            multiple
          >
            <el-option
              v-for="employeeGrade in employeeGrades"
              :key="employeeGrade.id"
              :label="employeeGrade.grade_name"
              :value="employeeGrade.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>

      <h3>Approval Details</h3>
      <el-form-item label="No of Approvals" prop="no_approvals">
        <el-input-number
          placeholder=""
          name="no_approvals"
          v-model.number="no_approvals"
          :min="1"
        >
        </el-input-number>
      </el-form-item>

      <div
        class="mt-20"
        v-for="(item, i) in leaveApprovalForm.approver_details"
        :key="item.id"
      >
        <el-form-item
          :prop="'approver_details.' + i + '.approver_person_id'"
          :label="'Approver Name ' + (i + 1)"
          :rules="{
            required: true,
            message: 'Please select approval person',
            trigger: 'blur',
          }"
        >
          <el-select
            v-model="
              leaveApprovalForm.approver_details[i]['approver_person_id']
            "
            placeholder="Select Approver"
            filterable
            remote
            :remote-method="searchEmployees"
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :prop="'approver_details.' + i + '.alt_approver_person_id'"
          :label="'Alt Approver Name ' + (i + 1)"
        >
          <el-select
            v-model="
              leaveApprovalForm.approver_details[i]['alt_approver_person_id']
            "
            placeholder=" Select Alt Approver"
            filterable
            remote
            :remote-method="searchEmployees"
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>

      <el-form-item label="Approval Type" prop="approval_types">
        <el-radio-group
          v-model="leaveApprovalForm.approval_types"
          class="mt-20"
        >
          <el-radio label="Concurrent">Concurrent</el-radio>
          <el-radio label="Sequential">Sequential</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="">
        <div class="btn-wrapper mt-20 sec-span">
          <el-button
            class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end mr-15"
            @click.prevent="create()"
            :loading="loading"
            >Create</el-button
          >
          <button
            class="btn btn-light-gray no-border btn-full-radius inline-flex flex-v-end mr-15"
            @click.prevent="$router.go(-1)"
          >
            Cancel
          </button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import debounce from "lodash.debounce";
import { onlyNumbers } from "@/helpers/validation.js";

const { mapState, mapActions } = createNamespacedHelpers("admin/hrm/leave");

export default {
  data() {
    const customValidation = (rule, value, callback) => {
      const categoryTypeMap = {
        employees: this.leaveApprovalForm.employees,
        department: this.leaveApprovalForm.departments
          ? [this.leaveApprovalForm.departments]
          : [],
        station_grade: this.leaveApprovalForm.grades,
        branch: this.leaveApprovalForm.branches,
      };

      if (!categoryTypeMap[this.leaveApprovalForm.category_type].length > 0) {
        return callback(new Error(`Please select ${rule.field}`));
      } else {
        return callback();
      }
    };
    return {
      loading: false,
      employees: [],
      no_approvals: 1,
      leaveApprovalForm: {
        description: "",
        branch_id: null,
        approval_types: "",
        no_approvals: 1,
        category_type: "employees",
        approver_details: [
          {
            approver_person_id: null,
            alt_approver_person_id: null,
          },
        ],
        departments: [],
        grades: [],
        employees: [],
        branches: [],
      },
      rules: {
        description: [
          {
            required: true,
            message: "Please input leave Approval list",
            trigger: "blur",
          },
        ],
        approval_types: [
          {
            required: true,
            message: "Please select approval type",
            trigger: "blur",
          },
        ],
        no_approvals: [
          {
            required: true,
            message: "Please input number of approver required",
            trigger: "blur",
          },
        ],
        category_type: [
          {
            required: true,
            message: "",
          },
        ],
        departments: [
          {
            required: true,
            message: "Please select department ",
            validator: customValidation,
          },
        ],
        branches: [
          {
            required: true,
            message: "Please select branch ",
            validator: customValidation,
          },
        ],
        grades: [
          {
            required: true,
            message: "Please select grade ",
            validator: customValidation,
          },
        ],
        employees: [
          {
            required: true,
            message: "Please select employee ",
            validator: customValidation,
          },
        ],
        approver_details: [
          {
            required: true,
            message: "Please input approver name",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getBranches();
    this.getEmployeeGrades();
    this.getDepartments();
  },
  computed: {
    ...mapState(["branches", "departments", "employeeGrades"]),
  },
  watch: {
    no_approvals: function(newValue, oldValue) {
      this.leaveApprovalForm.no_approvals = this.no_approvals;
      if (newValue === oldValue + 1) {
        this.leaveApprovalForm.approver_details.push({
          approver_person_id: null,
          alt_approver_person_id: null,
        });
        return;
      }
      this.leaveApprovalForm.approver_details = this.leaveApprovalForm.approver_details.slice(
        0,
        newValue
      );
    },
  },
  methods: {
    onlyNumbers,
    ...mapActions([
      "getBranches",
      "createLeaveApprover",
      "getEmployeeGrades",
      "getDepartments",
      "getLeaveApproverById",
    ]),
    create() {
      this.$refs[`leaveApprovalForm`].validate(valid => {
        if (valid) {
          this.loading = true;
          if (
            this.leaveApprovalForm.category_type === "employees" ||
            this.leaveApprovalForm.category_type === "branch"
          ) {
            this.leaveApprovalForm.branch_id = 0;
          }
          const inputData = {
            description: this.leaveApprovalForm.description,
            approval_types: this.leaveApprovalForm.approval_types,
            ...(this.leaveApprovalForm.category_type === "department" && {
              category_type: this.leaveApprovalForm.category_type,
              departments: this.leaveApprovalForm.departments,
            }),
            ...(this.leaveApprovalForm.category_type === "station_grade" && {
              category_type: this.leaveApprovalForm.category_type,
              grades: this.leaveApprovalForm.grades,
            }),
            ...(this.leaveApprovalForm.category_type === "employees" && {
              category_type: this.leaveApprovalForm.category_type,
              employees: this.leaveApprovalForm.employees,
            }),
            ...(this.leaveApprovalForm.category_type === "branch" && {
              category_type: this.leaveApprovalForm.category_type,
              branches: this.leaveApprovalForm.branches,
            }),
            branch_id: this.leaveApprovalForm.branch_id,
            approver_details: this.leaveApprovalForm.approver_details,
            no_approvals: this.leaveApprovalForm.no_approvals,
          };
          this.$store
            .dispatch("admin/hrm/leave/createLeaveApprover", inputData)
            .then(() => {
              this.loading = false;
              this.$router.push({
                path: "/admin/hrm/leave/settings/leave-approval",
              });
            })
            .catch(error => {
              this.$notification.error(error.message);
              this.loading = false;
            });
        }
      });
    },
    searchEmployees: debounce(function(searchQuery) {
      this.$store
        .dispatch("searchEmployees", searchQuery)
        .then(response => {
          this.employees = response;
        })
        .catch(() => {});
    }, 500),
  },
};
</script>
